<template>
  <div id="app">
    <!-- <div id="nav">
      <navbar>The emergency action plan</navbar>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>
    <router-view/> -->

    <!-- **
    * HEADER
    * -->
    <!--  NAVBAR -->
    <navbar
      @toggleMenu="toggleMenu"
      @toggleResource="showResource=true"
    >
      <!-- <div class="d-block d-md-none">ASSISTANT<br/>UMPIRE CLINIC</div> -->
      <div class="d-none d-md-block text-center">La sécurité en aviron</div>
    </navbar>
    <!-- <div class="menu-container" v-if="menuActive" @click="toggleMenu">
      <div class="course-menu">
        <h3>Course Menu</h3>
        <cac-menu :menuItems="$store.state.menuItems" @menu-clicked="toggleMenu"></cac-menu>
      </div>
    </div> -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      mode="out-in"
    >
      <div
        class="menu-sidebar"
        v-if="menuActive"
        @click="toggleMenu"
      >
        <router-link
          class="menu-sidebar__item"
          to="/"
        >
          <div class="menu-sidebar__status">
            <img
              src="@/assets/img/_menu/menu-status_complete.png"
              alt=""
            />
          </div>
          <div class="menu-sidebar__title">
            Accueil
          </div>
        </router-link>
        <div
          v-for="(item,index) in $store.state.menuItems"
          :key="index"
        >
          <!-- If the link is navigable, set up a router-link, otherwise set up link as span -->
          <router-link
            class="menu-sidebar__item"
            :class="{ disabled: item.activeLocation > $store.state.currentLocation }"
            :to="item.activeLink"
            v-if="item.activeLocation < $store.state.currentLocation"
          >
            <div class="menu-sidebar__status">
              <img
                :src="require(`@/assets/img/_menu/${item.sideMenuIcon}`)"
                alt=""
              />
            </div>
            <div class="menu-sidebar__title">
              {{item.title}}
            </div>
          </router-link>
          <span
            class="menu-sidebar__item"
            :class="{ disabled: item.activeLocation > $store.state.currentLocation }"
            v-else
          >
            <div class="menu-sidebar__status">
              <img
                :src="require(`@/assets/img/_menu/${item.sideMenuIcon}`)"
                alt=""
              />
            </div>
            <div class="menu-sidebar__title">
              {{item.title}}
            </div>
          </span>
        </div>
      </div>
    </transition>

    <!-- OPEN MODAL POPUPS FOR MENU
    <modal-popup v-if="showResource" @close="showResource = false">
      <text-content>
        <h3 class="text-content__header">Resources</h3>
        <ul>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" :href="`${publicPath}docs/rca-athlete-development-pathway.pdf`" target="_blank" rel="noopener noreferrer">RCA Athlete Development Pathway</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" :href="`${publicPath}docs/rca-can-row-coaches-handbook.pdf`" target="_blank" rel="noopener noreferrer">CAN ROW Coaches Handbook</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" :href="`${publicPath}docs/rca-safetyguidelines-2013.pdf`" target="_blank" rel="noopener noreferrer">Rowing Safely: RCA Safety Requirements and Safety Guidelines</a></li>
          <!-- <li><a class="modal-link" style="color:#fff; text-decoration: underline;" href="http://rowingcanada.org/rca-safety-video" target="_blank" rel="noopener noreferrer">RCA Safety Video Series</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" href="https://www.youtube.com/watch?v=vVOCsfJna3Q" target="_blank" rel="noopener noreferrer">RCA Safety Video Chapters 1-4</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" href="https://www.youtube.com/watch?time_continue=1&v=cmlpzKqJVEM" target="_blank" rel="noopener noreferrer">RCA Safety Video Chapter 5: Coaches</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" :href="`${publicPath}docs/rca-rowing-technique.pdf`" target="_blank" rel="noopener noreferrer">RCA Rowing Technique</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" :href="`${publicPath}docs/rca-para-leaflet.pdf`" target="_blank" rel="noopener noreferrer">RCA Para Rowing Classifications</a></li>
          <li><a class="modal-link" style="color:#fff; text-decoration: underline;" :href="`${publicPath}docs/cac-nccp-eap-form.pdf`" target="_blank" rel="noopener noreferrer">NCCP Emergency Action Plan template</a></li>
          <!-- <li>CAC EAP module</li>
        </ul>
      </text-content>
    </modal-popup> -->

    <!-- **
    * MAIN
    * -->
    <main
      id="main"
      role="main"
    >
      <router-view></router-view>
    </main>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
// import Banner from '@/components/Banner.vue';
// import BannerFullWidth from '@/components/BannerFullWidth.vue';
// import BannerBackgroundVideo from '@/components/BannerBackgroundVideo.vue';
// import BannerForegroundVideo from '@/components/BannerForegroundVideo.vue';
import ContentBlock from '@/components/ContentBlock.vue';
// import Accordion from '@/components/Accordion.vue';
// import Quiz from '@/components/Quiz.vue';
// import QuizMultipleQuestions from '@/components/QuizMultipleQuestions.vue';
// import Carousel from '@/components/Carousel.vue';
// import Quote from '@/components/Quote.vue';
import ModalPopup from '@/components/ModalPopup.vue';
// import OrderedList from '@/components/OrderedList.vue';
// import QuizCheckbox from '@/components/QuizCheckbox.vue';

// // CAC BLOCKS
// import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';

import { SCORM } from 'pipwerks-scorm-api-wrapper';

export default {
  name: 'app',
  components: {
    Navbar,
    // Banner,
    // BannerFullWidth,
    // BannerBackgroundVideo,
    // BannerForegroundVideo,
    ContentBlock,
    // Accordion,
    // Quiz,
    // QuizMultipleQuestions,
    // Carousel,
    // Quote,
    ModalPopup,
    // OrderedList,
    // QuizCheckbox,

    // CAC BLOCKS
    // CacHeader,
    CacMenu,
  },
  data() {
    return {
      menuActive: false,
      showResource: false,
      publicPath: process.env.BASE_URL,
    };
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;
    },
  },
  mounted() {
    /**
     * Insert SCORM hooks
     */
    // SCORM.version = '1.2'
    // let success = SCORM.init()
    // let currentLocation
    // if (success) {
    //   this.$store.state.currentLocation = SCORM.get("cmi.core.lesson_location")
    //   currentLocation = this.$store.state.currentLocation

    //   switch (true) {
    //     case (currentLocation >= 1):
    //       this.$router.push('/coaching-rca-adp')
    //       break;

    //     case (currentLocation >= 13):
    //       this.$router.push('/identifying-managing-safety-risks')
    //       break;

    //     case (currentLocation >= 33):
    //       this.$router.push('/using-an-eap')
    //       break;

    //     case (currentLocation >= 44):
    //       this.$router.push('/wrap-up')
    //       break;

    //     default:
    //       this.$router.push('/')
    //       break;
    //   }
    // }
    this.$store.dispatch('initCourse');
  },
  beforeDestroy() {
    // var status = SCORM.get("cmi.completion_status");
    // if(status !== "completed"){
    //     SCORM.set("cmi.completion_status", "incomplete")
    // }
    // SCORM.set("cmi.session_time", this.convertToSCORM2004Time(this.totalTime) )

    SCORM.set('cmi.core.lesson_location', this.$store.state.currentLocation);
    if (obj.n >= 46) {
      console.log('Course Complete');
      SCORM.set('cmi.core.lesson_status', 'completed');
    } else {
      SCORM.set('cmi.core.lesson_status', 'incomplete');
    }
    // if (this.$store.state.currentLocation >= 12) {
    //   SCORM.set('cmi.core.lesson_status', 'completed');
    // }
    SCORM.save();
    SCORM.quit();
  },
};
</script>

<style lang="scss">
/*------------------------------------*\
  #FONTS
\*------------------------------------*/
// <!-- Import Montserrat Adobe font -->
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,700|Open+Sans:400,700");
$fontStack-header: "Gotham", "Montserrat", "Open Sans", Helvetica, Arial,
  sans-serif;
$fontStack-body: "Open Sans", Helvetica, Arial, sans-serif;

/*------------------------------------*\
  #PRIMARY COLOURS
\*------------------------------------*/
@import "./styles/colors";

/*------------------------------------*\
  #Mixins
\*------------------------------------*/

/*------------------------------------*\
  #Extends
\*------------------------------------*/
@import "./styles/extends";

/*------------------------------------
  #MEDIA SCREENS < 768px (#MOBILE FIRST)
\*------------------------------------*/
/**
* Set fonts to Gotham
*/
h1,
h2,
h3,
h4,
h5 {
  font-family: $fontStack-header !important;
}
p,
ul,
li,
td,
th,
label,
button,
div {
  font-family: $fontStack-body !important;
}

// Add top margin to main content
#main {
  margin-top: 4rem;
}

/**
* Backgrounds
*/
.bg-charcoal {
  background-color: $charcoal;
  color: #fff;
}

.bg-light-grey {
  background-color: $light-grey;
}

.bg-red {
  background-color: $red;
  color: #fff;
}

.bg-light-red {
  background-color: $light-red;
}

.bg-light-red-100 {
  background-color: rgba($color: $red, $alpha: 0.5);
}

.bg-light-red-200 {
  background-color: rgba($color: $red, $alpha: 0.3);
}

.bg-orange {
  background-color: $light-orange;
  background-size: cover;
  color: #fff;

  // Modifiers
  &--gradient {
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#f26b22),
      to(#dc2628)
    );
    background: linear-gradient(to right, #f26b22, #dc2628);
  }

  &--plain {
    background: $orange;
    color: #000;
  }
}

/**
* BG IMG
*/
.bg-img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  // MODS
  &--01 {
    background-image: url("./assets/img/_bg/lt-bkrnd1.png");
  }

  &--02 {
    background-image: url("./assets/img/_bg/lt-bkrnd2.png");
  }

  &--03 {
    background-image: url("./assets/img/_bg/lt-bkrnd3.png");
  }

  &--04 {
    background-image: url("./assets/img/_bg/lt-bkrnd4.png");
  }

  &--05 {
    background-image: url("./assets/img/_bg/lt-bkrnd5.png");
  }
}

.quiz-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  background-image: url("./assets/img/_bg/quiz-bkrnd.jpg");
}

/**
* CAROUSEL
*/
.carousel-img {
  img {
    border: 1px solid;
    max-height: 60vh;
  }
}

.carousel {
  h3 {
    color: $dark-red;
    font-size: 1.3rem;
    font-weight: 200;
  }

  &__text {
    // max-width: 300px;
    padding: 1rem;
    margin: 1rem;
    // min-height: 200px;
    background-color: #fff;
    // color: $blue;
    box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.5);
  }

  &__icon {
  }

  .slick-prev {
    left: -10px;
  }
  .slick-next {
    right: -10px;
  }
  .slick-prev,
  .slick-next {
    &::before {
      font-family: "slick";
      font-size: 20px;
      line-height: 1;
      opacity: 0.75;
      color: $dark-red;
    }
  }

  // SET CAROUSELS TO EQUAL HEIGHTS
  .slick-track {
    display: flex;

    .slick-slide {
      height: auto;

      > div {
        height: 100%;
        // display: flex;
        // flex-wrap: wrap;
        // height: 100%;

        > div {
          height: 100%;
          // padding: 0rem;
          padding-bottom: 2rem;

          > div {
            height: 100%;
          }
        }
      }
    }
  }
  /*------------------------------------*\
    #MEDIA SCREENS > 767px (TABLETS)
  \*------------------------------------*/
  @media (min-width: 767px) {
    .slick-prev,
    .slick-next {
      &::before {
        font-size: 35px;
      }
    }

    .slick-prev {
      left: -35px;
    }
    .slick-next {
      right: -20px;
    }
  }
}

/**
* Custom text colors
*/
.text-red {
  color: $dark-red;
}

.text-key-take {
  color: $dark-red;
  font-size: 1.3em;
}

.text-white {
  color: #fff;
}

/**
* Menu Container
*/
.menu-container {
  height: 100vh;
  background-color: $red;
  // padding-top: 4rem;
  position: fixed;
  z-index: 1025;
}

.menu-sidebar {
  background-color: $red;
  position: fixed;
  top: 3rem;
  width: 100vw;
  height: 100vh;
  color: #fff;
  z-index: 9999;
  padding: 1rem;

  &__item {
    padding: 1rem;
    display: flex;
    border-bottom: 1px solid #fff;
  }

  &__status {
    display: block;
    margin-right: 2rem;
  }

  &__title {
    display: block;
    color: #fff;
  }
}

/**
* Seperated line
*/
.seperator-line {
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(50%, #d20a11),
    color-stop(50%, #48545a)
  );
  background: linear-gradient(to right, $red 50%, $dark-grey 50%);
  height: 4px;
}

/**
* FIGURE
*/
.figure {
  margin-bottom: 3rem;
  display: block;
  text-align: center;
  .figure-caption {
    &::before {
      content: url("./assets/img/_icons/divider-mbl.png");
      position: absolute;
      left: calc(50% - 150px);
      margin-top: 25px;
    }
  }
}

// TABLE HACK
.table-responsive {
  display: table;
}

/**
* General Button Styling
*/
.btn-cac {
  color: $dark-grey;
  border: 2px solid $dark-grey;
  // border-radius: 25px;
  background: transparent;
  padding: 10px 30px;
  margin: 2rem auto 1rem;
  display: block;
  width: auto;
  min-width: 150px;

  &:focus {
    background: $dark-grey;
    color: #fff;
  }
  &:hover {
    background: $dark-grey;
    color: #fff;
    border: 2px solid $dark-grey;
  }

  /**
  * Modifiers
  */
  &--white {
    color: #fff;
    border-color: #fff;
    background: transparent;

    &:focus {
      background: #fff;
      color: $dark-grey;
    }
    &:hover {
      background: #fff;
      color: $dark-grey;
    }
  }

  &--red {
    color: $dark-red;
    border-color: $dark-red;
    background: transparent;

    &:focus {
      background: #fff;
      color: $dark-red;
    }
    &:hover {
      background: $dark-red;
      color: #fff;
      border: 2px solid $dark-red;
    }
  }

  &--orange {
    color: $orange;
    border-color: $orange;
    background: transparent;

    &:focus {
      background: #fff;
      color: $orange;
    }
    &:hover {
      background: $orange;
      color: #fff;
      border: 2px solid $orange;
    }
  }
}

/**
* Video Container
*/
.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;

  &__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

/**
* Portrait Icon
*/
.text-scenario {
  .block {
    margin-bottom: -10em;
  }

  // ELEMENTS
  &__table {
    background-color: #f99d1c;
    color: #48545a;
    border-radius: 10px;
    min-height: 25em;
    padding: 2em;
    margin-bottom: 2em;

    li {
      margin-bottom: 1em;
    }

    // modifier
    &--red {
      background-color: $dark-red;
      color: #fff;
    }
  }

  // Modifiers
  box-shadow: 0px 20px 20px #eee;
  // margin-bottom: 10rem;

  &--charcoal {
    &::after {
      margin-top: -10rem;
      top: 110px;
      content: url("./assets/img/_nav/text-scenario-arrow.png");
    }
  }

  &--light-grey {
    &::after {
      content: url("./assets/img/_nav/text-scenario-arrow_light-grey.png");
    }
  }

  &--white {
    &::after {
      content: url("./assets/img/_nav/text-scenario-arrow_white.png");
    }
  }

  &--orange {
    &::after {
      margin-top: -3rem;
      top: 38px;
      content: url("./assets/img/_nav/text-scenario-arrow_orange.png");
    }
  }

  &--red {
    &::after {
      margin-top: -3rem;
      top: 37px;
      content: url("./assets/img/_nav/text-scenario-arrow_red.png");
    }
  }
  //
  &::after {
    // content: url("../assets/img/icons/text-scenario-arrow.png");
    display: block;

    position: relative;
    text-align: center;
    width: 100%;
  }

  .block {
    margin-bottom: -10em;
  }
}

/**
*   Striped lists, full width
*/
.striped-list {
  // make full width on mobile
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  padding: 2em 0;
  li {
    padding: 1rem 15px;
    text-align: left;
    list-style: none;
    min-height: 5rem;
    display: flex;
    align-items: center;

    // remove p margin
    p {
      margin-bottom: 0;
    }

    &:nth-child(odd) {
      background: $light-grey;
    }
  }

  // Elements
  &__icon {
    float: left;
    margin-right: 1em;
    display: block;
  }
}

/**
*   Solid-list, full width
*/
.solid-list {
  // make full width on mobile
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
  padding: 2em 0 0;
  li {
    padding: 1rem 15px;
    text-align: left;
    list-style: none;
    min-height: 5rem;
    border-bottom: 1px solid #fff;
    display: flex;
    align-items: center;

    // remove p margin
    p {
      margin-bottom: 0;
    }
  }

  // Elements
  &__icon {
    float: left;
    margin-right: 1em;
    display: block;
  }

  // Modifiers
}

/**
* CHEVRON LIST
*/
.chevron-list {
  // list-style-image: url('./assets/img/_icons/check.png');
  list-style-type: none;
  // padding-left: 30px;
  li {
    margin-bottom: 1rem;
    padding-left: 0px;
    position: relative;
    ol,
    ul {
      margin-top: 1rem;
      // margin-left: 1.5rem;
      li {
        &::before {
          content: none;
        }
      }
    }

    &::before {
      content: url("./assets/img/_icons/chevron--red.svg");
      position: absolute;
      float: left;
      top: 5px;
      width: 30px;
      // margin-right: 10px;
      left: -40px;
    }
  }
}

/**
* GRID LIST
*/
.grid-list {
  list-style: none;
  padding: 0;
  margin: 1rem 0;
  li {
    border-bottom: 1px solid $red;
    text-decoration: none;
    padding: 1rem 0;

    &:last-of-type {
      border-bottom: none;
    }
  }
}

.grid-list--border-right {
  border-right: 1px solid $red;
}

.grid-list--border-left {
  border-left: 1px solid $red;
  padding: 0 1rem;
}

/**
*   Accordion Modifiers
*/
// add top/bottom margins to accordions
.accordion-group {
  margin: 1rem 0px;
}

.accordion {
  .accordion__button {
    font-weight: 700;
  }

  .accordion__panel {
    background-color: $light-grey;
  }
}

.accordion--light-grey {
  .accordion__button {
    background-color: $light-grey !important;
    color: #000 !important;
    border: 1px solid #ccc !important;

    &:after {
      // content: '\003e' !important;
      color: $dark-red !important;
      // transform: rotate(90deg);
    }
  }

  .accordion__panel {
    background-color: #fff !important;
  }
}

.accordion--dark-grey {
  .accordion__button {
    background-color: $dark-grey;
    color: #fff;
    border: 1px solid #fff;
  }
  .accordion__panel {
    background-color: $light-grey;
  }
}

.accordion--charcoal {
  .accordion__button {
    background-color: $dark-grey;
    color: #fff;
    border: 1px solid #fff;
  }
}

.accordion--orange {
  .accordion__button {
    background-color: $orange;
    color: #000;
    border: 1px solid #fff;
  }
}

.accordion--red {
  .accordion__button {
    background-color: $para-rowers-red;
    color: #fff;
    border: 1px solid #fff;
  }
}

.accordion--green {
  .accordion__button {
    background-color: $para-rowers-green;
    color: #000;
    border: 1px solid #fff;
  }
  .accordion__panel {
    background-color: $light-grey;
  }
}

.accordion--blue {
  .accordion__button {
    background-color: $para-rowers-blue;
    color: #000;
    border: 1px solid #fff;
  }
  .accordion__panel {
    background-color: $light-grey;
  }
}

.accordion--light-blue {
  .accordion__button {
    background-color: $light-blue;
    color: #000;
    border: 1px solid #fff;
  }
  .accordion__panel {
    background-color: $light-grey;
  }
}

/**
*   List Rowers
*/
.rower-list {
  padding: 1rem;

  &__header {
    color: $red;
    font-weight: 700;
    text-align: center;
  }

  &__img {
    margin-bottom: 1rem;
  }
}

/**
*   2-01-06 para Rowers
*/
.para-rowers {
  padding: 2rem;
  text-align: center;

  // ELEMENTS
  &__header {
    font-size: 3rem;
  }

  &__description {
    padding: 0.5rem;
    border: 2px solid;
    width: 50%;
    display: block;
    margin: auto;
  }

  &__img {
    max-height: 200px;
    margin: 2rem 0;
  }

  // Modifiers
  &--green {
    background-color: $para-rowers-green;
  }

  &--blue {
    background-color: $para-rowers-blue;
    color: #fff;
  }

  &--red {
    background-color: $para-rowers-red;
    color: #fff;
  }
}

/**
 PADDLE BORDER
*/
.paddle-border {
  position: relative;

  &::before {
    // content: url('./assets/img/_nav/paddle-list.png');
    content: " ";
    background: url("./assets/img/_nav/paddle-list.png");
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    background-size: contain;
    position: relative;
    display: block;
    left: 10px;
    width: calc(100% - 30px);
    height: 50px;
    position: absolute;
    bottom: -30px;
  }
}

/**
*   List With paddle spacers
*/
.list-paddle {
  // list-style-image: url('./assets/img/_nav/list-icon.png');
  list-style: none;
  margin-left: -1rem;
  li {
    background: url("./assets/img/_nav/paddle-list.png");
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    background-size: contain;
    line-height: 1.5rem;
    padding: 1.5rem 0 1rem;
    margin-left: -20px;
    // padding-left: 25px;
    // border-bottom: 2px solid #707070;
    // border-image: url('../assets/img/_nav/paddle-list.png') 0 0 50 0 stretch;
  }

  &:after {
    content: "  ";
    background: url("./assets/img/_nav/paddle-list.png");
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    background-size: contain;
    position: relative;
    display: block;
    left: -2%;
    width: 102%;
    height: 50px;
  }
}

/**
* TABLE HEAD
*/
.thead--red {
  background-color: $red;
  color: #fff;
  text-align: left;
}

/**
*   Course Menu
*/
.course-menu {
  background-size: cover;
  background-position: center;
  // color: #fff;
  background-color: #f7f0ef;
  text-align: center;
  padding-top: 2rem;
}

/**
*   Banner Quotes
*/
.section-quote {
  padding: 0rem 0;
}

.table-centered {
  td {
    vertical-align: inherit;
  }
}

/**
*   make full width on mobile
*/
.fw-mbl {
  position: relative;
  width: 100vw;
  left: 50%;
  margin-left: -50vw;
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  .striped-list {
    position: relative;
    left: auto;
    margin-left: auto;
    width: 100%;
  }

  .solid-list {
    position: relative;
    left: auto;
    margin-left: auto;
    width: 100%;
  }

  // Menu
  .menu-sidebar {
    right: 0;
    width: 50%;
    top: 4rem;
  }

  /**
  *   make full width on mobile
  */
  .fw-mbl {
    position: relative;
    left: auto;
    margin-left: auto;
    width: 100%;
  }
}

/**
* MODAL BUTTON
*/
.modal-btn {
  border: 2px solid $red;
  position: relative;

  &::after {
    content: url('./assets/img/_icons/rca-expand.svg');
    position: absolute;
    bottom: -2px;
    right: -2px;
    background-color: #fff;
    border: 2px solid $red;
    // left: 46%;
    z-index: 1;
    width: 50px;
    height: 50px;
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 992px
  (LAPTOP, TABLET)
\*------------------------------------*/
@media (min-width: 992px) {
  // Menu
  .menu-sidebar {
    right: 0;
    width: 35%;
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 1200px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1320px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
  #MEDIA SCREENS > 1600px (DESKTOP)
\*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
